import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toggleStats } from '../../../../../actions/ui';
import { exportRowsToCsv, exportRowsToExcel } from '../../../../../helpers/export-helper';

export const ProjectListHeaderActions = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { visibleProjects, statsCollapsed } = useSelector((state) => state.ui);

    const [isExportOpen, setIsExportOpen] = useState(false);

    const exportRows = Array.isArray(visibleProjects) ? visibleProjects : [];
    const exportColumns = [
        { key: 'code', header: 'Código' },
        { key: 'name', header: 'Proyecto' },
        { key: 'customer', header: 'Cliente' },
        { key: 'status', header: 'Estatus' },
        { key: 'startDate', header: 'Inicio' },
        { key: 'endDate', header: 'Fin' },
    ];

    const handleToggleStats = () => {
        dispatch(toggleStats());
    };

    const getNormalizedRows = () => {
        return exportRows.map((project) => ({
            code: project.code || '',
            name: project.name || '',
            customer: project.customerName || '',
            status: project.status || '',
            startDate: project.startDate ? new Date(project.startDate).toLocaleDateString('es-MX') : '',
            endDate: project.endDate ? new Date(project.endDate).toLocaleDateString('es-MX') : '',
        }));
    };

    const handleDownloadCsv = () => {
        const rows = getNormalizedRows();
        exportRowsToCsv({
            rows,
            columns: exportColumns,
            baseFileName: 'proyectos_visibles',
        });
        setIsExportOpen(false);
    };

    const handleDownloadExcel = () => {
        const rows = getNormalizedRows();
        exportRowsToExcel({
            rows,
            columns: exportColumns,
            baseFileName: 'proyectos_visibles',
            sheetName: 'Proyectos',
        });
        setIsExportOpen(false);
    };

    const handleDocumentClick = (event) => {
        const exportDropdown = event.target.closest('.dropdown');
        if (!exportDropdown) {
            setIsExportOpen(false);
        }
    };

    const handleExportClick = () => {
        setIsExportOpen(!isExportOpen);
    };

    React.useEffect(() => {
        document.addEventListener('click', handleDocumentClick);
        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, []);

    return (
        <div className="page-header-right ms-auto">
            <div className="page-header-right-items">
                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                    <button type="button" className={`btn btn-icon btn-light-brand toolbar-toggle-btn ${statsCollapsed ? 'toolbar-toggle-btn--active' : ''}`} data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded={statsCollapsed} aria-controls="collapseOne" onClick={handleToggleStats}>
                        <i className="feather-bar-chart"></i>
                    </button>
                    <div className="dropdown">
                        <button type="button" className="btn btn-icon btn-light-brand" data-bs-toggle="dropdown" data-bs-offset="0, 10" data-bs-auto-close="outside" aria-expanded="false" onClick={handleExportClick}>
                            <i className="feather-paperclip"></i>
                        </button>
                        <div className={`dropdown-menu dropdown-menu-end ${isExportOpen ? 'show' : ''}`}>
                            <button type="button" className="dropdown-item d-flex align-items-center gap-2" onClick={handleDownloadCsv} disabled={exportRows.length === 0}>
                                <i className="feather-file"></i>
                                <span>CSV</span>
                            </button>
                            <button type="button" className="dropdown-item d-flex align-items-center gap-2" onClick={handleDownloadExcel} disabled={exportRows.length === 0}>
                                <i className="feather-grid"></i>
                                <span>Excel</span>
                            </button>
                        </div>
                    </div>

                    <button type="button" className="btn btn-primary" onClick={() => navigate('/project/create')}>
                        <i className="feather-plus me-2"></i>
                        <span>Nuevo</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
